<lex-doc-viewer-dialog>
    <div dialog-title>{{model.targetDisplayTitle}}</div>
    <div dialog-body>
        <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start">
            <mat-tab label="Edit">
                <div style="display: flex; flex-direction: column; height:250px; overflow: auto;">
                    <div *ngIf="controlType==='folder'">
                        <lex-folder-tree-view-new (clicked)="folderSelect($event)"></lex-folder-tree-view-new>
                    </div>
                </div>
            </mat-tab>
        </mat-tab-group>
    </div>
    <div dialog-actions>
        <div style="display:flex; flex-direction: row; justify-content: flex-end; padding: 12px; gap: 4px;">
            <lex-flat-button (click)="ok()" [type]="'action'" label="Ok"></lex-flat-button>
            <lex-flat-button [type]="'action'" label="Cancel" matDialogClose></lex-flat-button>
        </div>
    </div>
</lex-doc-viewer-dialog>